import styled from '@emotion/styled'

import { ReactComponent as SendInvitationIllustration } from '../../../../../../../../../../assets/images/organization-users-settings/invitation-modal-send-invitation.svg'

export const SendInvitation = styled(SendInvitationIllustration)`
  display: block;
  max-width: 195px;
  margin: 0 auto;
`
